<template>
  <!--分享@我详情-->
  <div aria-labelledby="myModalLabel" class="modal fade" id="shareinfo" role="dialog" tabindex="-1">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <span aria-hidden="true">×</span>
          </button>
          <ul class="nav nav-tabs modal-tabs" id="myTab">
            <li v-if="shareInfo.share_type === 'link'">
              <a data-toggle="tab" href="#link">链接分享详情</a>
            </li>
            <li v-if="shareInfo.share_type === 'user'">
              <a data-toggle="tab" href="#user">用户分享详情</a>
            </li>
            <li v-if="shareInfo.share_type === 'group'">
              <a data-toggle="tab" href="#group">群组分享详情</a>
            </li>
            <li v-if="shareInfo.link_number">
              <a data-toggle="tab" href="#publish">发布详情</a>
            </li>
          </ul>
        </div>
        <div class="modal-body">
          <div class="tab-content" id="myTabContent">
            <div
              class="tab-pane fade in2 active2"
              :id="shareInfo.share_type ? shareInfo.share_type : 'publish'"
            >
              <dl class="sharedetail">
                <dt>
                  <div class="item-icon">
                    <svg aria-hidden="true" class="icon">
                      <use xlink:href="#icon-folder-zy" />
                    </svg>
                  </div>
                  <div
                    class="cont"
                  >{{shareInfo.share_title ? shareInfo.share_title : shareInfo.link_title}}</div>
                </dt>
                <dd>
                  <label>{{shareInfo.share_type ? '分享时间' : '发布时间'}}</label>
                  <div
                    class="cont"
                  >{{shareInfo.share_type ? shareInfo.share_created_date : shareInfo.link_created_date}}</div>
                </dd>
                <dd v-if="shareInfo.share_type === 'link'">
                  <label>访问链接</label>
                  <div class="cont" style="word-wrap:break-word;word-break:break-all;">
                    {{share_url}}
                    <button
                      type="button"
                      ref="copy"
                      class="btn btn-primary btn-xs"
                      @click="copy"
                      data-toggle="tooltip"
                      data-placement="left"
                    >{{copyText}}</button>
                  </div>
                </dd>
                <dd
                  v-if="tab === 'sharefile' && ( shareInfo.share_type === 'user' || shareInfo.share_type === 'group' )"
                >
                  <label>分享给</label>
                  <div
                    class="cont"
                    v-if="shareInfo.share_sharers && !shareInfo.share_sharers.length"
                  >无</div>
                  <div
                    class="cont"
                    v-if="shareInfo.share_sharers && shareInfo.share_sharers.length"
                  >
                    <div
                      class="list"
                      v-for="share_sharers in shareInfo.share_sharers"
                      :key="share_sharers.sharer_number"
                    >
                      <i class="ti-user"></i>
                      <p>{{share_sharers.sharer_name}}</p>
                    </div>
                  </div>
                </dd>
                <dd>
                  <label>{{shareInfo.link_number ? '发布自' : '分享自'}}</label>
                  <div class="cont">
                    <div class="list">
                      <i class="ti-user"></i>
                      <p>{{shareInfo.link_number ? shareInfo.link_creater_name : shareInfo.share_creater_name}}</p>
                    </div>
                  </div>
                </dd>
                <dd v-if="shareInfo.share_type === 'link' || shareInfo.link_number">
                  <label>密码</label>
                  <div
                    class="cont"
                    v-if="shareInfo.share_type === 'link'"
                  >{{shareInfo.share_constraint && shareInfo.share_constraint.password && shareInfo.share_constraint.password ? shareInfo.share_constraint.password : '无密码'}}</div>
                  <div
                    class="cont"
                    v-else
                  >{{shareInfo.link_constraint && shareInfo.link_constraint.password && shareInfo.link_constraint.password ? shareInfo.link_constraint.password : '无密码'}}</div>
                </dd>
                <dd>
                  <label>有效期</label>
                  <div
                    v-if="shareInfo.link_number"
                    class="cont"
                  >{{shareInfo.link_constraint && shareInfo.link_constraint.date && shareInfo.link_constraint.date ? shareInfo.link_constraint.date : '不限制'}}</div>
                  <div
                    v-else
                    class="cont"
                  >{{shareInfo.share_constraint && shareInfo.share_constraint.date && shareInfo.share_constraint.date ? shareInfo.share_constraint.date : '不限制'}}</div>
                </dd>
                <dd v-if="shareInfo.link_number">
                  <label>允许访问IP</label>
                  <div
                    class="cont"
                    v-if="shareInfo.link_constraint && shareInfo.link_constraint.ip && shareInfo.link_constraint.ip.length"
                  >
                    <span v-for="(ip, index) in shareInfo.link_constraint.ip" :key="ip">
                      <span v-if="index !== 0">、</span>
                      {{ip}}
                    </span>
                  </div>
                  <div v-else class="cont">不限制</div>
                </dd>
                <!-- <dd v-if="shareInfo.link_number">
                  <label>允许访问域</label>
                  <div
                    class="cont"
                    v-if="shareInfo.link_constraint && shareInfo.link_constraint.host && shareInfo.link_constraint.host.length"
                  >
                    <span v-for="(host, index) in shareInfo.link_constraint.host" :key="host">
                      <span v-if="index !== 0">、</span>
                      {{host}}
                    </span>
                  </div>
                  <div v-else class="cont">不限制</div>
                </dd>-->
              </dl>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-primary" data-dismiss="modal" type="button">关闭</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShareInfo",
  data() {
    return {
      copyText: "复制链接"
    };
  },
  computed: {
    shareInfo() {
      return this.$store.state.drive.shareInfo;
    },
    tab() {
      return this.$store.state.drive.tab;
    },
    share_url() {
      let routeUrl = this.$router.resolve({
        name: "sharelink",
        params: { share_number: this.shareInfo.share_number }
      });
      return window.location.origin + routeUrl.href;
    }
  },
  methods: {
    copy() {
      let container = this.$refs.copy;
      let pwd =
        this.shareInfo.share_constraint &&
        this.shareInfo.share_constraint.password
          ? `密码：${this.shareInfo.share_constraint.password}`
          : "";
      let copy = `链接：${this.share_url}${pwd}`;
      this.$copyText(copy, container)
        .then(() => {
          this.copyText = "已复制";
        })
        .catch(() => {
          this.copyText = "复制失败";
          alert("复制失败，建议您手动复制");
        });
      setTimeout(() => {
        this.copyText = "重新复制";
      }, 2000);
    }
  },
  mounted() {
    $("#shareinfo").on("show.bs.modal", () => {
      this.copyText =
        this.shareInfo.share_constraint &&
        this.shareInfo.share_constraint.password
          ? "复制链接及密码"
          : "复制链接";
    });
  }
};
</script>

<style scoped>
.cont .btn-xs {
  padding: 1px 5px;
  margin-bottom: 3px;
}
.fade.in2 {
  opacity: 1;
}
.tab-content > .active2 {
  display: block;
}
</style>